const COLORS = {
  primary: "#2039CC",
  secundary: "#2D3748",
  third: "#438CD8",
};

export { COLORS };
